import { render, staticRenderFns } from "./CBSApiGatewayApplicationInfoList.vue?vue&type=template&id=478c4b92&"
import script from "./CBSApiGatewayApplicationInfoList.vue?vue&type=script&lang=js&"
export * from "./CBSApiGatewayApplicationInfoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports